<template>
  <div>
    <AlertDismiss ref="alertDismiss" class="mx-2"></AlertDismiss>

    <b-table
        :busy="isBusy"
        :fields="fields"
        :items="filteredItems"
        select-mode="single"
        selectable
        show-empty
        sticky-header="500px"
    >
      <template #empty>
        <b-card v-if="items === null" class="text-center my-2 fs-5">
          Descargando información declaraciones...
        </b-card>
        <b-card v-else-if="items.length !== 0" class="text-center my-2 fs-5">
          No hay declaraciones que coincidan con los criterios de búsqueda
        </b-card>
        <b-card v-else class="text-center my-2 fs-5">
          Aún no se ha creado ninguna declaración
        </b-card>
      </template>

      <!-- Icono de carga de tabla -->
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ms-2">Cargando datos de tabla...</strong>
        </div>
      </template>

      <!--boton de detalles -->
      <template #cell(details)="row">
        <b-button class="mr-2" size="sm" variant="outline-secondary" @click="row.toggleDetails">
          <div v-if="row.detailsShowing">
            <small class="d-none d-md-inline me-2">Ocultar</small>
            <b-icon font-scale="1" icon="eye-slash-fill"></b-icon>
          </div>
          <div v-else>
            <small class="d-none d-md-inline me-2">Ver</small>
            <b-icon font-scale="1" icon="eye-fill"></b-icon>
          </div>
        </b-button>
      </template>

      <template #cell(document)="row">
        <template v-if="row.rowSelected">
          <b-button
              v-b-tooltip.hover="'Mostrar evidencia'"
              size="sm"
              type="button"
              variant="outline-primary"
              @click="openModalStatementDocument(row)"
          >
            <b-icon font-scale="1" icon="file-earmark-medical-fill"></b-icon>
          </b-button>
        </template>
        <template v-else>
          <b-icon class="icone-not-select" font-scale="1" icon="three-dots"></b-icon>
        </template>
      </template>

      <!--cuerpo de detalle-->
      <template #row-details="row">
        <div class="card">
          <div class="card-body m-0 p-1">
            <small>
              <b-table-lite
                  :fields="questionFields"
                  :items="row.item.answers"
                  class="m-0"
                  small
              >
              </b-table-lite>
            </small>
          </div>
        </div>
      </template>

    </b-table>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import {EventNames, InitPageSize} from '@/plugins/enums/index.js'
import {applyAccuserFilter, formatDateTime} from '@/plugins/complianceScripts/index.js'

export default {
  name: 'StatementsTable',

  data() {
    return {
      isBusy: false,
      items: null,
      searchQuery: '',
      dataQuery: null,
      questions: null,

      fields: [
        // {key: 'formName', label: 'Nombre formulario'},
        {key: 'name', label: 'Nombre declarante'},
        {key: 'declarantMail', label: 'Correo declarante'},
        {key: 'creationDate', label: 'Fecha de creación', formatter: formatDateTime},
        {key: 'details', label: 'Detalle', thClass: 'col-2'},
        {key: 'document', label: 'Documento', thClass: 'col-1'},
      ],

      questionFields: [
        {key: 'questionName', label: 'Pregunta'},
        {key: 'answerIsCorrect', label: 'Respuesta', formatter: (value) => value ? 'Sí' : 'No'},
        {key: 'answerTextDepth', label: 'Profundización'},
      ],
    }
  },

  async mounted() {
    this.$eventBus.$on(EventNames.PaginationFilterStatements, async (query) => {
      this.isBusy = true;

      let page = query.page - 1; //se resta 1 porque el indice comienza en 0
      let pageSize = query.pageSize;

      await this.getStatements(page, pageSize);

      this.isBusy = false;
    });

    this.$eventBus.$on(EventNames.FilterStatementsAfterSearch, (query) => {
      this.isBusy = true;

      this.searchQuery = query

      this.isBusy = false;
    });

    this.$eventBus.$on(EventNames.CreatedStatement, async () => {
      this.isBusy = true;

      await this.getStatements(0, InitPageSize.StatementsPageSize);

      this.isBusy = false;
    });

    this.$eventBus.$on(EventNames.ClearStatementsDateFilter, async () => {
      if (!this.dateQuery) {
        return
      }
      this.isBusy = true
      this.dateQuery = null;

      await this.getStatements(0, InitPageSize.StatementsPageSize);

      this.isBusy = false;
    });

    this.$eventBus.$on(EventNames.FilterStatementsByDate, async (query) => {
      this.isBusy = true;

      this.dateQuery = query;

      await this.getStatementsByDate(query);

      this.isBusy = false;
    });
  },

  components: {
    AlertDismiss
  },

  computed: {
    ...mapGetters(["getRole", "getSession"]),
    filteredItems() {
      let filtered = this.items;

      // Filtrar por búsqueda por nombre, apellido, etc.
      if (this.searchQuery) {
        filtered = this.filterForSearch(filtered, this.searchQuery)
      }

      return filtered;
    },
  },

  methods: {
    ...mapActions(["getAllStatementsByPage", "getAllStatementsByDate"]),

    async getStatementsByDate(query) {
      let options = {
        initDate: query.startDate,
        finalDate: query.endDate
      }

      let mail = this.getSession.mail;
      let roleFilter = applyAccuserFilter(mail, this.getRole);
      if (roleFilter) {
        options.declarantMail = mail;
      }

      let statements = await this.getAllStatementsByDate(options);
      if (statements.isError) {
        this.$refs.alertDismiss.showAlert(statements.message);
        return;
      }

      this.items = this.processStatements(statements.data)
    },

    async getStatements(page, pageSize) {
      let options = {
          page: page,
          pageSize: pageSize
      }
      let mail = this.getSession.mail;
      let roleFilter = applyAccuserFilter(mail, this.getRole);
      if (roleFilter) {
          options.declarantMail = mail;
      }

      let statements = await this.getAllStatementsByPage(options);
      if (statements.isError) {
          this.$refs.alertDismiss.showAlert(statements.message);
          return;
      }

      this.items = this.processStatements(statements.data)
    },

    processStatements(statements) {
      return statements.map(statement => {
        return {
          name: statement.declarant.name,
          declarantMail: statement.declarant.mail,
          documentId: statement.documentId,
          creationDate: statement.creationDate,
          answers: statement.questionAndAnswers,
          route: statement.document.route
        }
      })
    },
  
    openModalStatementDocument(row) {
      this.$eventBus.$emit(EventNames.OpenModalStatementDocument, row.item.route);
    },

    filterForSearch(statements, searchQuery) {
      const normalizedQuery = searchQuery.toLowerCase().trim();

      return statements.filter(item =>
          Object.values(item).some(value => {
              if (value) {
                return value.toString().toLowerCase().includes(normalizedQuery)
              
              }
              return false
          }
          )
      );
    },

    formatValue(cell) {
      if (cell === "") { // if the field was not included in the response it will be an empty string
        return ""
      } else if (cell.type === 'bool') {
        return cell.answer === "true" ? 'Sí' : 'No'
      } else if (cell.type === 'select') {
        return cell.answer
      } else if (cell.type === 'form') {
        return JSON.stringify(cell)
      } else {
        if (cell.answer.startsWith('"') && cell.answer.endsWith('"')) {
          return cell.answer.substring(1, cell.answer.length - 1)
        }
        return cell.answer
      }
    },

    buildFields(obj) {
      let id = obj.questionId
      let keys
      if (id in this.questions) {
        keys = this.questions[id].options.map(x => x.descripcion)
      } else {
        keys = Object.keys(obj.answer[0])
      }

      return keys.map(key => {
        return {
          key: key,
          label: key
        }
      })
    }
  },
}
</script>
